const normalize = (value = '') =>
  String(value)
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const getManagerStageApprovers = (request = {}) =>
  Array.isArray(request?.requestApprovers)
    ? request.requestApprovers.filter(
        (approver) => normalize(approver?.stage) === 'manager'
      )
    : [];

export const hasAssignedManagers = (request = {}) =>
  getManagerStageApprovers(request).length > 0;

export const hasAnyManagerApproved = (request = {}) =>
  getManagerStageApprovers(request).some(
    (approver) => normalize(approver?.decision) === 'approved'
  );

export const isAdminBookingLockedByManager = (request = {}) =>
  hasAssignedManagers(request) && !hasAnyManagerApproved(request);

export const isAdminApprovedBooking = (request = {}) => {
  const currentStage = normalize(request?.currentStage);
  const status = normalize(request?.status);
  const bookingStatus = normalize(request?.bookingDetails?.bookingStatus);

  return (
    currentStage === 'completed' &&
    status === 'booked' &&
    bookingStatus === 'success' &&
    Boolean(request?.adminApprovedBy) &&
    Boolean(request?.adminApprovedAt)
  );
};

export const isBookingEditClosed = (request = {}) => {
  const currentStage = normalize(request?.currentStage);
  const status = normalize(request?.status);

  if (currentStage === 'completed') {
    return true;
  }

  return ['booked', 'approved', 'cancelled', 'declined', 'rejected'].includes(
    status
  );
};

export const canEditBookingDetailsForAdmin = (request = {}) => {
  const currentStage = normalize(request?.currentStage);

  if (isAdminBookingLockedByManager(request)) {
    return false;
  }

  if (isAdminApprovedBooking(request)) {
    return true;
  }

  if (isBookingEditClosed(request)) {
    return false;
  }

  return ['admin', 'booking'].includes(currentStage);
};

export const shouldShowAdminBookingAction = (request = {}) => {
  const currentStage = normalize(request?.currentStage);

  if (isAdminApprovedBooking(request)) {
    return true;
  }

  if (isBookingEditClosed(request)) {
    return false;
  }

  return ['manager', 'admin', 'booking'].includes(currentStage);
};